import { render, staticRenderFns } from "./OnayamiList.vue?vue&type=template&id=1ba597af&"
import script from "./OnayamiList.vue?vue&type=script&lang=ts&"
export * from "./OnayamiList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports